const fontWeights = {
  light: 300,
  base: 400,
  normal: 500,
  normalBold: 600,
  medium: 700,
  bold: 900,
} as const;

export default fontWeights;
